import CidadeService from "../../services/CidadeService";
import FormSelectSearchModal from "../forms/base/FormSelectSearchModal";
import FormCidade from "../../pages/Cidade/FormCidade";
import Permissao from "../../controllers/Permissao";

export default class SelectCidadeByEstado extends FormSelectSearchModal {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);
        this.receivEventDispach = this.receivEventDispach.bind(this);

        this.state.showBtns = this.props.showBtns === undefined ? true : this.props.showBtns;
        this.state.showBtnSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
        this.state.showBtnNewForm = this.state.showBtns && ((this.props.showBtnNewForm === undefined ? true : false) && Permissao.getInstance().getPermissao(6));
        this.state.showBtnNewSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
    }

    componentDidUpdate(nextProps) {
        super.componentDidUpdate(nextProps);
        if (nextProps.idEstado !== this.props.idEstado) {
            this.getOptions();
        }
    }

    componentDidMount() {
        super.componentDidMount();

        this.getOptions();

        if (this.dispachChangeDidMount && this.props.value) {
            this.handleChange({ target: { value: this.props.value, name: this.props.name } });
        }

        this.state.headers = [
            { key: "value", label: "Código", className: 'text-center d-none d-md-table-cell' },
            { key: "label", label: "Nome da Cidade" },
        ];
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getConfigFormNew() {

        return {
            title: 'Cadastro de Estado',
            sizeModal: 'modal-xl',
            config: {
                isModal: true,
                idPais: this.props.idPais,
                idEstado: this.props.idEstado
            },
            form: FormCidade,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idCidade) {
                        this.handleOpenSearch(null, response.data?.idCidade);
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };

    };

    getOptions(callBack) {
        if (this.props.idEstado) {
            CidadeService.getForComboByEstado(this.props.idEstado, (response) => {
                this.setState({ options: response }, () => {
                    if (callBack) {
                        callBack();
                    }
                });
            });
        } else {
            this.setState({ options: [] }, () => {
                if (callBack) {
                    callBack();
                }
            });
        }
    }

    render() {
        return super.render();
    }
}